import { Component, Input, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-illustration-header',
  templateUrl: './illustration-header.component.html',
  styleUrls: ['./illustration-header.component.css']
})
export class IllustrationHeaderComponent implements OnInit {
  @Input() futureTotalCost: Number;
  @Input() futureTotalCostLTC: Number;
  @Input() netPresentValue: Number;
  @Input() socialSecurityDeduction: Number;
  @Input() remainUnfundedCost: Number;
  @Input() additionalFunds: Number;
  @Input() investmentToFund: Number;
  @Input() investmentType: string;
  @Input() isSrcReport: string;
  @Input() imgSrc: string;
  @Input() hasFunding: boolean = false;
  @Input() socialSecurityScenarios: any;//string[];
  @Input() clientObject: any;

  @Output() fundingSourceEvent = new EventEmitter<any>();
  @Output() adjustedLongTermCareEvent = new EventEmitter<any>();
  @Output() socialSecuritySourceEvent = new EventEmitter<any>();
  @Output() desiredClaimAgeChangeEvent = new EventEmitter<any>();
  
  hideSocialSecurity:boolean = false;
  targetCard = {
    longTermCareCard: 'longTermCareCard',
    lifeTimeCostCard : 'lifeTimeCostCard',
    lifeTimeCostCardAddSS : 'lifeTimeCostCardAddSS',
    socialSecurityDeductionCard:'socialSecurityDeductionCard',
    additionalFundsCard:'additionalFundsCard',
    remainingUnfundedCard:'remainingUnfundedCard',
    startInvestmentCard:'startInvestmentCard',
    investmentSolution: 'investmentSolution',
    medicareDeductions: 'medicareDeductions',
    netPresentValue: 'netPresentValue'
  }


  constructor(private matDialog: MatDialog,) { 
    this.fundingSourceEvent = new EventEmitter();
  }

  ngOnInit() {
    console.log('investmentType', this.investmentType)
  }

  returnedFundingSource(data){
    console.log('returned data', data);
    this.fundingSourceEvent.emit(data);
  }

  returnedAdjustedLongTermCare(data){
    console.log('returned adjust LTC data', data);
    this.adjustedLongTermCareEvent.emit(data);
  }

  returnedSocialSecurity(data){
    //TODO: need to recalc without SS
    console.log('triggered SS return from header');
    this.socialSecuritySourceEvent.emit(data);
    this.hideSocialSecurity = true;
  }

  onSocialSecurityScenarioChange(scenario: any) {
    this.desiredClaimAgeChangeEvent.emit(scenario.target.value);
  }

  returnedEstimatedLifeTimeCosts(data){
    //TODO: recalc with SS
    this.hideSocialSecurity = false;
    this.socialSecuritySourceEvent.emit(data);
  }
}
